<template>
<div class="chapter">
<div class="inner_page">
<p class="txc">
<i>For George W. Smalley (1930-2003) and for the students of Lawrence University who
					thumbed Skippy, ogled onion domes, and, laughing, set up tents in the rain on the
					“Slavic Trips,” 1969 to 1991.</i> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?ac741712